<script>
import { mapActions, mapState } from "vuex";
import cryptoRandomString from "crypto-random-string";
import compUmat from "@/components/form/umat";
import compUmatBaptis from "@/components/form/baptis";
import compUmatModal from "@/components/modal/umat";
import compKeluargaKatolikModal from "@/components/modal/keluargaKatolik";
import umatOpt from "@/data/umatOpt";

export default {
	name: "baptisForm",
	components: {
		"comp-umat": compUmat,
		"comp-umat-baptis": compUmatBaptis,
		"comp-umat-modal": compUmatModal,
		"comp-keluarga-katolik-modal": compKeluargaKatolikModal,
	},
	data() {
		return {
			mode: "INSERT",
			uid: "",
			myOptions: {
				kriteria: umatOpt.kriteria,
				jk: umatOpt.jk,
				gol_darah: umatOpt.golDarah,
			},
			trigger: {
				umat: 0,
				baptis: 0,
			},
			kk: {},
		};
	},
	computed: {
		isLoading() {
			return this.$store.state.isLoading;
		},
		...mapState({
			umatItem: (state) => state.umat.item,
			umatBabtisItem: (state) => state.umatBaptis.item,
			lingkunganStasi: (state) => state.service.lingkunganStasi,
		}),
	},
	created() {},
	mounted() {
		this.getLingkunganStasi();

		this.$store.dispatch("umat/resetItem");
		this.$store.dispatch("umatBaptis/resetItem");

		this.uid = cryptoRandomString({
			length: 32,
			type: "distinguishable",
		});

		this.umatItem.uid = this.uid;
		this.umatBabtisItem.uid = this.uid;

		if (typeof this.$route.params.id !== "undefined") {
			this.mode = "UPDATE";

			this.getItemBaptis(this.$route.params.id).then(
				(response) => {
					this.setItemUmat(response.data.umat);
					this.setItemBabtis(response.data.baptis);
				},
				() => {
					this.$router.push("/baptis");
				}
			);
		} else {
			this.$swal({
				title: "Apakah umat baru atau lama?",
				text: "",
				icon: "warning",
				showCancelButton: true,
				confirmButtonText: "Lama",
				cancelButtonText: "Baru",
				html: false,
				allowOutsideClick: false,
				preConfirm: () => {
					this.$modal.show("umatModal");
				},
			}).then((result) => {
				if (typeof result.dismiss !== "undefined") {
					if (result.dismiss == "cancel") {
						// this.autoFill();
					}
				}
			});
		}
	},
	methods: {
		...mapActions({
			insert: "umatBaptis/insert",
			update: "umatBaptis/update",
			getItemBaptis: "umatBaptis/getItem",
			setItemBabtis: "umatBaptis/setItem",
			setItemUmat: "umat/setItemForm",
			getItemUmat: "umat/getItem",
			getItemKK: "keluargaKatolik/getItem",
			getLingkunganStasi: "service/getLingkunganStasi",
		}),
		handleSumbmit() {
			this.trigger.umat = !this.trigger.umat;
		},
		async validateUmat(result) {
			await result.then((valid) => {
				if (!valid) {
					this.$toast.error("Identitas Umat belum lengkap");
				} else {
					this.trigger.baptis = !this.trigger.baptis;
				}
			});
		},
		async validateBaptis(result) {
			await result.then((valid) => {
				if (!valid) {
					this.$toast.error("Data Baptis belum lengkap");
				} else {
					this.onSubmit();
				}
			});
		},
		onSubmit() {
			const data = {
				umat: this.umatItem,
				baptis: this.umatBabtisItem,
				kk: this.kk,
			};

			if (this.mode === "INSERT") {
				this.insert(data).then(() => {
					this.$router.push("/baptis");
				});
			} else {
				this.update(data).then(() => {
					this.$router.push("/baptis");
				});
			}
		},
		onCancel() {
			this.$router.push("/baptis");
		},
		onRowClick(uid) {
			this.getItemUmat(uid).then((response) => {
				const umat = response.data.umat;

				if (umat.is_baptis) {
					this.$toast.error("Umat ini sudah dibaptis");
					return;
				}

				this.setItemUmat(umat);
				this.umatBabtisItem.uid = umat.uid;
				this.$modal.hide("umatModal");
			});
		},
		showModalKK() {
			this.$modal.show("kkModal");
		},
		onCancelKK() {
			this.$modal.hide("kkModal");
		},
		onRowClickKK(uid) {
			this.getItemKK(uid).then((response) => {
				this.kk = response.data.keluarga_katolik;
				this.$modal.hide("kkModal");
			});
		},
		autoFill() {
			this.umatItem.nama = this.$faker().name.findName();
			this.umatItem.tempat_lahir = this.$faker().address.city();
			this.umatItem.alamat = this.$faker().address.streetName();
			this.umatItem.tgl_lahir = "2000-01-01";
			this.umatItem.jk = "L";
			this.umatItem.suku = "Dayak";

			this.umatItem.keuskupan = "Keuskupan Sintang";
			this.umatItem.paroki = "Paroki Kristus Raja Katedral Sintang";
			this.umatItem.lingkungan_stasi = "Stasi Jerora 1";
			this.umatItem.kabupaten = "Sintang";
			this.umatItem.kecamatan = "Sintang  ";
			this.umatItem.desa = "Jerora Satu";
			this.umatItem.agama = "Katolik";
			this.umatItem.pekerjaan = "Konsultan";
			this.umatItem.pendidikan = "S1";
			this.umatItem.jurusan = "Teknik Infomatika";
			this.umatItem.nik = "61287318273";
			this.umatItem.nohp = "081255225454";
			this.umatItem.email = "Dayak@gmail.com";
			this.umatItem.gol_darah = "O";
			this.umatItem.aktivitas = "Warga Biasa";
			this.umatItem.profesi = [{ text: "Guru", value: "Guru" }];
			this.umatItem.keterampilan = [{ text: "Musik", value: "Musik" }];
			this.umatItem.status_kawin = "Menikah";
			this.umatItem.cacat_tubuh = "Tidak";

			this.umatBabtisItem.no_buku = "12345";
			this.umatBabtisItem.no_lb = "54321";
			this.umatBabtisItem.nama_baptis = this.$faker().name.findName();
			this.umatBabtisItem.tanggal = "2020-04-03";
			this.umatBabtisItem.kriteria = "Bayi";
			this.umatBabtisItem.keuskupan_lb = "Keuskupan Sintang";
			this.umatBabtisItem.paroki_lb = "Paroki Katedral Kristus Raja Sintang";
			this.umatBabtisItem.wali = this.$faker().name.findName();
			this.umatBabtisItem.wali2 = this.$faker().name.findName();
			this.umatBabtisItem.pembaptis = this.$faker().name.findName();
		},
	},
};
</script>

<template>
	<div>
		<vue-fab
			mainBtnColor="#0071B3"
			:scrollAutoHide="false"
			size="big"
			:globalOptions="{ spacing: 50, delay: 0.05 }"
			icon="menu"
		>
			<fab-item
				@clickItem="handleSumbmit"
				:idx="0"
				title="Simpan"
				icon="save"
			/>
			<!-- <fab-item
				@clickItem="autoFill"
				:idx="1"
				title="Auto Fill"
				icon="input"
			/> -->
		</vue-fab>

		<Breadcrumbs main="Baptis" title="Form Baptis" />
		<!-- Container-fluid starts-->
		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<form
						@submit.stop.prevent="onSubmit"
						v-if="isLoading"
						id="form-data"
					></form>
					<px-card>
						<div slot="with-padding">
							<h5 class="text-muted">Identitas Umat :</h5>
							<hr />
							<comp-umat
								@validate="validateUmat"
								:triggerValidation="trigger.umat"
							></comp-umat>
						</div>
					</px-card>
					<px-card>
						<div slot="with-padding">
							<h5 class="text-muted">Data Baptis :</h5>
							<hr />
							<comp-umat-baptis
								@validate="validateBaptis"
								:triggerValidation="trigger.baptis"
							></comp-umat-baptis>
						</div>
					</px-card>

					<!-- <px-card>
						<div slot="with-padding">
							<h5 class="text-muted">Data Keluarga Katolik :</h5>
							<p>Menghubungkan umat dengan data Keluarga Katolik</p>
							<hr />
							<b-button
								variant="primary"
								size="sm"
								@click="showModalKK()"
								><i class="fa fa-plus"></i> Cari Data</b-button
							>
							<hr />
							<div class="row">
								<div class="col-md-3">
									<div class="form-group">
										<label>Nomor</label>
										<b-form-input
											v-model="kk.nomor"
											size="sm"
											readonly
										></b-form-input>
									</div>
								</div>
								<div class="col-md-3">
									<div class="form-group">
										<label>Nama Kepala keluarga</label>
										<b-form-input
											v-model="kk.kepala_keluarga"
											size="sm"
											readonly
										></b-form-input>
									</div>
								</div>
								<div class="col-md-3">
									<div class="form-group">
										<label>Paroki</label>
										<b-form-input
											v-model="kk.paroki"
											size="sm"
											readonly
										></b-form-input>
									</div>
								</div>
								<div class="col-md-3">
									<div class="form-group">
										<label>Lingkungan/Stasi</label>
										<b-form-input
											v-model="kk.lingkungan_stasi"
											size="sm"
											readonly
										></b-form-input>
									</div>
								</div>
							</div>
						</div>
					</px-card> -->
				</div>
			</div>
		</div>

		<modal name="umatModal" width="80%" height="80%" :clickToClose="false">
			<template>
				<div class="myModal">
					<div class="row">
						<div class="col-md-12">
							<b-button-group class="btn-group">
								<b-button
									variant="danger"
									@click="onCancel()"
									v-b-tooltip.hover
									title="Batal"
									><i class="fa fa-close"></i> Batal</b-button
								>
							</b-button-group>
							<hr />
						</div>
						<div class="col-md-12">
							<comp-umat-modal @onRowClick="onRowClick" />
						</div>
					</div>
				</div>
			</template>
		</modal>

		<modal name="kkModal" width="80%" height="80%" :clickToClose="false">
			<template>
				<div class="myModal">
					<div class="row">
						<div class="col-md-12">
							<b-button-group class="btn-group">
								<b-button
									variant="danger"
									@click="onCancelKK()"
									v-b-tooltip.hover
									title="Batal"
									><i class="fa fa-close"></i> Batal</b-button
								>
							</b-button-group>
							<hr />
						</div>
						<div class="col-md-12">
							<comp-keluarga-katolik-modal @onRowClick="onRowClickKK" />
						</div>
					</div>
				</div>
			</template>
		</modal>
	</div>
</template>

<style scoped>
.myModal {
	padding: 20px;
	scroll-behavior: smooth;
}
::v-deep .vm--modal {
	overflow-y: auto;
}
.modal-card {
	margin: 0px;
}
</style>